import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Switch } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { useRolesAndPermissions } from '../../../context/RolesAndPermissionsContext'
import {
  Container,
  Header,
  Title,
  Content,
  AccessList,
  Access,
  AccessTitle,
  AccessDescription,
} from './styled'

const Accesses = () => {
  const { t } = useTranslation()
  const { roleDetail: data, setAccess } = useRolesAndPermissions()
  const isPermissionsDisabled = data.isDefault
  const prefix = 'configuration.rolesAndPermissions.form.sections'
  const [isOpen, setIsOpen] = useState({
    learningManagement: true,
    participantsAndCourseProgress: true,
    operationalManagement: true,
    globalVisualization: true,
  })

  return (
    <>
      <Container>
        <Header
          onClick={() =>
            setIsOpen({
              ...isOpen,
              learningManagement: !isOpen.learningManagement,
            })
          }
        >
          <Button type="link">
            <FontAwesomeIcon
              icon={isOpen.learningManagement ? faChevronUp : faChevronDown}
            />
          </Button>
          <Title>{t(`${prefix}.learningManagement.title`)}</Title>
        </Header>
        <Content
          open={isOpen.learningManagement}
          disabled={isPermissionsDisabled}
        >
          <AccessList>
            <Access>
              <Switch
                checked={data.accesses.manageInternalCourses}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('manageInternalCourses', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageInternalCourses.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageInternalCourses.description`)}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.manageExternalCourses}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('manageExternalCourses', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageExternalCourses.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageExternalCourses.description`)}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.manageLearningPrograms}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('manageLearningPrograms', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageLearningPrograms.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageLearningPrograms.description`)}
              </AccessDescription>
            </Access>
          </AccessList>
        </Content>
      </Container>
      <Container>
        <Header
          onClick={() =>
            setIsOpen({
              ...isOpen,
              participantsAndCourseProgress:
                !isOpen.participantsAndCourseProgress,
            })
          }
        >
          <Button type="link">
            <FontAwesomeIcon
              icon={
                isOpen.participantsAndCourseProgress
                  ? faChevronUp
                  : faChevronDown
              }
            />
          </Button>
          <Title>{t(`${prefix}.participantsAndCourseProgress.title`)}</Title>
        </Header>
        <Content
          open={isOpen.participantsAndCourseProgress}
          disabled={isPermissionsDisabled}
        >
          <AccessList>
            <Access>
              <Switch
                checked={data.accesses.viewCourseInformation}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('viewCourseInformation', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.viewCourseInformation.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.viewCourseInformation.description`)}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.downloadReport}
                disabled={isPermissionsDisabled}
                onChange={(checked) => setAccess('downloadReport', checked)}
              />
              <AccessTitle>
                {t(`${prefix}.accesses.downloadReport.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.downloadReport.description`)}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.manageParticipants}
                disabled={isPermissionsDisabled}
                onChange={(checked) => setAccess('manageParticipants', checked)}
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageParticipants.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageParticipants.description`)}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.manageProgress}
                disabled={isPermissionsDisabled}
                onChange={(checked) => setAccess('manageProgress', checked)}
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageProgress.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageProgress.description`)}
              </AccessDescription>
            </Access>
          </AccessList>
        </Content>
      </Container>
      <Container>
        <Header
          onClick={() =>
            setIsOpen({
              ...isOpen,
              operationalManagement: !isOpen.operationalManagement,
            })
          }
        >
          <Button type="link">
            <FontAwesomeIcon
              icon={isOpen.operationalManagement ? faChevronUp : faChevronDown}
            />
          </Button>
          <Title>{t(`${prefix}.operationalManagement.title`)}</Title>
        </Header>
        <Content
          open={isOpen.operationalManagement}
          disabled={isPermissionsDisabled}
        >
          <AccessList>
            <Access>
              <Switch
                checked={data.accesses.manageAdministratorRequests}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('manageAdministratorRequests', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageAdministratorRequests.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(
                  `${prefix}.accesses.manageAdministratorRequests.description`
                )}
              </AccessDescription>
            </Access>
            <Access>
              <Switch
                checked={data.accesses.manageMessages}
                disabled={isPermissionsDisabled}
                onChange={(checked) => setAccess('manageMessages', checked)}
              />
              <AccessTitle>
                {t(`${prefix}.accesses.manageMessages.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.manageMessages.description`)}
              </AccessDescription>
            </Access>
          </AccessList>
        </Content>
      </Container>
      <Container>
        <Header
          onClick={() =>
            setIsOpen({
              ...isOpen,
              globalVisualization: !isOpen.globalVisualization,
            })
          }
        >
          <Button type="link">
            <FontAwesomeIcon
              icon={isOpen.globalVisualization ? faChevronUp : faChevronDown}
            />
          </Button>
          <Title>{t(`${prefix}.globalVisualization.title`)}</Title>
        </Header>
        <Content
          open={isOpen.globalVisualization}
          disabled={isPermissionsDisabled}
        >
          <AccessList>
            <Access>
              <Switch
                checked={data.accesses.viewGlobalMonitoring}
                disabled={isPermissionsDisabled}
                onChange={(checked) =>
                  setAccess('viewGlobalMonitoring', checked)
                }
              />
              <AccessTitle>
                {t(`${prefix}.accesses.viewGlobalMonitoring.title`)}
              </AccessTitle>
              <AccessDescription>
                {t(`${prefix}.accesses.viewGlobalMonitoring.description`)}
              </AccessDescription>
            </Access>
          </AccessList>
        </Content>
      </Container>
    </>
  )
}

export default Accesses
